export default __webpack_public_path__ + "static/media/pups-logo-01.88947eb3.png";